import { render } from "./MenuWideTile.vue?vue&type=template&id=133d9b8b&scoped=true"
import script from "./MenuWideTile.vue?vue&type=script&lang=js"
export * from "./MenuWideTile.vue?vue&type=script&lang=js"

import "./MenuWideTile.vue?vue&type=style&index=0&id=133d9b8b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133d9b8b"]])

export default __exports__